var map = {
	"./pages/agregar/agregar.module": [
		"./src/app/pages/agregar/agregar.module.ts",
		"default~pages-agregar-agregar-module~pages-configuracion-configuracion-module~pages-edicion-edicion-~e5391bdc",
		"pages-agregar-agregar-module"
	],
	"./pages/configuracion/configuracion.module": [
		"./src/app/pages/configuracion/configuracion.module.ts",
		"default~pages-agregar-agregar-module~pages-configuracion-configuracion-module~pages-edicion-edicion-~e5391bdc",
		"pages-configuracion-configuracion-module"
	],
	"./pages/creditos/creditos.module": [
		"./src/app/pages/creditos/creditos.module.ts",
		"default~pages-creditos-creditos-module~pages-reportes-reportes-module~pages-ventas-ventas-module",
		"pages-creditos-creditos-module"
	],
	"./pages/edicion/edicion.module": [
		"./src/app/pages/edicion/edicion.module.ts",
		"default~pages-agregar-agregar-module~pages-configuracion-configuracion-module~pages-edicion-edicion-~e5391bdc",
		"pages-edicion-edicion-module"
	],
	"./pages/gastos/gastos.module": [
		"./src/app/pages/gastos/gastos.module.ts",
		"default~pages-agregar-agregar-module~pages-configuracion-configuracion-module~pages-edicion-edicion-~e5391bdc",
		"pages-gastos-gastos-module"
	],
	"./pages/graficas/graficas.module": [
		"./src/app/pages/graficas/graficas.module.ts",
		"default~pages-graficas-graficas-module~pages-reportes-reportes-module",
		"pages-graficas-graficas-module"
	],
	"./pages/inventario/inventario.module": [
		"./src/app/pages/inventario/inventario.module.ts",
		"pages-inventario-inventario-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"./pages/reportes/reportes.module": [
		"./src/app/pages/reportes/reportes.module.ts",
		"default~pages-creditos-creditos-module~pages-reportes-reportes-module~pages-ventas-ventas-module",
		"default~pages-graficas-graficas-module~pages-reportes-reportes-module",
		"pages-reportes-reportes-module"
	],
	"./pages/ventas/ventas.module": [
		"./src/app/pages/ventas/ventas.module.ts",
		"default~pages-agregar-agregar-module~pages-configuracion-configuracion-module~pages-edicion-edicion-~e5391bdc",
		"default~pages-creditos-creditos-module~pages-reportes-reportes-module~pages-ventas-ventas-module",
		"pages-ventas-ventas-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;